import React, { useCallback, useState, useEffect } from 'react'
import { useModal } from 'react-modal-hook'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import AccountDisplay from '../../../components/account-display/account-display'
import BeneficiaryDisplay from '../../../components/beneficiary-display/beneficiary-display'
import Modal from '../../../components/Modal/Modal'
import NeoButton from '../../../components/NeoButton/NeoButton'
import LayoutWithAccountCard from '../../../layout/Layout/layout-account-card'
import { InternalTransferSchema, OtherTransferSchema } from '../../../schemas/beneficiary-transfer'
import { carouselCurrentItemSelector, getFeatureListSelector } from '../../../selectors'
import DashboardService from '../../../services/dashboard.service'
import { Formik, Form, Field } from 'formik'
import NeoInput from '../../../components/NeoInput/NeoInput'
import InputError from '../../../components/InputError/InputError'
import NeoSuccess from '../../../components/FormComponents/NeoSuccess'
import NeoOTP from '../../../components/FormComponents/NeoOTP'
import Loading from 'custom/assets/loaders/Loading'
import { useTranslation } from 'react-i18next'
import config from 'custom/config/environment'
import {
  BENEFICIARY_TRANSFER_KEYS,
  AUTH_KEYS,
  RECIPTS_KEYS,
  DIALOG_KEYS,
  DEPOSITS_KEYS,
  REQUESTS_KEYS,
  SIDENAV_KEYS,
  VALIDATION_MESSAGES,
} from '../../../utils/translation-constants'
import BeneficiaryTransferService from '../../../services/beneficiary-transfers.service'
import { setAccRefresh } from '../../../actions'
import TermsAndCondition from '../../../components/TermsAndConditions/TermsAndCondition'
import NumberFormat from 'react-number-format'

import validationConfig from 'custom/config/validation.config.json'
import AuthService from '../../../services/auth.service'
const otherTransferConfig = validationConfig['transfers']['domestic']

export default function OtherAccountTransfer() {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const [stage, setStage] = useState(1)
  const [otp, setOtp] = useState('')
  const [otpEnabled, setOtpEnabled] = useState(false)
  const [beneDetails, setBeneDetails] = useState({})
  const [formValues, setFormValues] = useState({})
  const [verifyDetails, setVerifyDetails] = useState({})
  const [transferType, setTransferType] = useState({})
  const [currencyList, setCurrencyList] = useState([])
  const [remarksList, setRemarksList] = useState([])
  const [confirmMessage, setConfirmMessage] = useState()
  const currentAccountDetail = useSelector(carouselCurrentItemSelector)
  const { t } = useTranslation()
  const featureList = useSelector(getFeatureListSelector)
  const [successResponse, setSuccessResponse] = useState({})
  const [custDetails, setCustDetails] = useState({})

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>
            <b>{message?.code}</b> : {message?.message}
          </h6>
          <div className='modal-btn-style'>
            <NeoButton
              mode='newDesign'
              type='button'
              text={t(DIALOG_KEYS.CLOSE)}
              onClick={() => {
                hideModal()
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [message],
  )
  const [showConfirmModal, hideConfirmModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>{confirmMessage}</h6>
          <div className='mt-4 d-flex justify-content-evenly'>
            <div className='col-6'>
              <NeoButton
                mode='newDesign'
                type='button'
                text={t(DIALOG_KEYS.CONFIRM_YES)}
                onClick={() => {
                  hideConfirmModal()
                  otpEnabled ? setStage(3) : onConfirm()
                }}
              />
            </div>
            <div className='col-6'>
              <NeoButton
                mode='newDesign'
                type='button'
                text={t(DIALOG_KEYS.CONFIRM_NO)}
                onClick={() => {
                  hideConfirmModal()
                  history.push('/beneficiary-transfers/transfers')
                }}
              />
            </div>
          </div>
        </div>
      </Modal>
    ),
    [confirmMessage, otpEnabled],
  )
  useEffect(() => {
    if (location.state === undefined) {
      history.push('/beneficiary-transfers')
      return
    }
    setBeneDetails(location?.state?.beneDetails)
    setTransferType(location?.state?.transferType)
    getRemarksList()
    getUserDetails()
  }, [])

  const getRemarksList = useCallback(async () => {
    try {
      const response = await DashboardService.getRemarksCategory()
      if (response.status === 200) {
        setLoading(false)
        setRemarksList(response.data.remarks)
      }
    } catch (err) {}
  }, [dispatch])

  const getUserDetails = useCallback(async () => {
    try {
      setLoading(true)
      const response = await AuthService.getUserProfile()
      if (response?.profileDetails) {
        setLoading(false)
        setCustDetails(response?.profileDetails)
      }
    } catch (err) {
      setLoading(false)
    }
  }, [])

  const onVerify = useCallback(
    async (values) => {
      try {
        if (values.transferType === 'DDACC') {
          if (featureList['BENE_DDACC'][currentAccountDetail['accountType']] === 'N') {
            setMessage({
              code: t(DIALOG_KEYS.NO_ACCESS),
              message: t(DIALOG_KEYS.NO_ACCOUNTS),
            })
            showModal()
            return
          }
        }
        if (values.transferType === 'RTGS') {
          if (featureList['BENE_RTGS'][currentAccountDetail['accountType']] === 'N') {
            setMessage({
              code: t(DIALOG_KEYS.NO_ACCESS),
              message: t(DIALOG_KEYS.NO_ACCOUNTS),
            })
            showModal()
            return
          }
        }

        setLoading(true)
        setFormValues(values)
        if (values.transferAmount === '0.00' || values.transferAmount === '.00') {
          return
        }
        const reqParams = {
          fin: {
            srcAccount: currentAccountDetail?.accountNo,
            srcAccBranch: currentAccountDetail?.brnCode,
            srcAccCcy: currentAccountDetail?.currency,
            destAccount: beneDetails?.beneAccNo,
            destAccBranch: '',
            destAccCcy: '',
            destBankName: '',
            bicCode: '',
            sortCode: '',
            txnCurrency: values.txnCurrency,
            amount: values.transferAmount,
            remarks: values.remarks === 'Custom' ? values.customRemarks : values.remarks,
          },
          nfin: {
            transferType: values.transferType,
            beneId: beneDetails?.beneId,
            scheduled: values.isScheduled === 'Yes' ? true : false,
            scheduledDate: values.scheduledDate,
            beneficiaryName: '',
            beneficiaryMail: '',
            beneficiaryMobile: '',
            addBeneficiary: false,
          },
          cdf: {
            FXREFNO: '',
            add1: custDetails.add1,
            mobileNo: custDetails.mobileNo,
          },
          requestId: values.transferType === 'DDACC' ? 'FTVERIFYDDACC' : 'FTVERIFYRTGS',
        }
        const response = await BeneficiaryTransferService.verifyFundTransfer(reqParams)
        if (response.status === 200) {
          setOtpEnabled(response.data['otpEnabled'])
          setVerifyDetails(response.data)
          setConfirmMessage(response.data['message'])
          setStage(2)
          setLoading(false)
        }
      } catch (err) {
        setLoading(false)
      }
    },
    [beneDetails, transferType, currentAccountDetail, featureList, custDetails],
  )

  const onConfirm = useCallback(async () => {
    try {
      setLoading(true)
      const reqParams = {
        fin: {
          srcAccount: currentAccountDetail?.accountNo,
          srcAccBranch: currentAccountDetail?.brnCode,
          srcAccCcy: currentAccountDetail?.currency,
          destAccount: beneDetails?.beneAccNo,
          destAccBranch: '',
          destAccCcy: '',
          destBankName: '',
          bicCode: '',
          sortCode: '',
          txnCurrency: formValues.txnCurrency,
          amount: formValues.transferAmount,
          remarks: formValues.remarks === 'Custom' ? formValues.customRemarks : formValues.remarks,
        },
        nfin: {
          transferType: formValues.transferType,
          beneId: beneDetails?.beneId,
          scheduled: formValues.isScheduled === 'Yes' ? true : false,
          scheduledDate: formValues.scheduledDate,
          beneficiaryName: '',
          beneficiaryMail: '',
          beneficiaryMobile: '',
          addBeneficiary: false,
          otp: verifyDetails.otpEnabled ? otp : '0000',
        },
        cdf: {
          FXREFNO: '',
          add1: custDetails.add1,
          mobileNo: custDetails.mobileNo,
        },
        requestId: formValues.transferType === 'DDACC' ? 'FTCONFIRMDDACC' : 'FTCONFIRMRTGS',
        module: 'FUNDTRANSFER',
      }
      const response = await BeneficiaryTransferService.confirmFundTransfer(reqParams)
      if (response.status === 200) {
        dispatch(setAccRefresh(true))
        setSuccessResponse(response.data)
        setMessage(response.data['message'])
        setStage(4)
        setLoading(false)
      }
    } catch (err) {
      setOtp('')
      setLoading(false)
    }
  }, [beneDetails, transferType, currentAccountDetail, otp, formValues, custDetails])

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm()
      case 2:
        return renderConfirm()
      case 3:
        return <NeoOTP otp={otp} setOTP={setOtp} onSubmit={onConfirm} loading={loading} />
      case 4:
        return (
          <NeoSuccess
            onClick1={() =>
              BeneficiaryTransferService.downLoadReport({
                transRefNum: successResponse.referenceNo,
                refId: '',
                module: 'FUNDTRANSFER',
              })
            }
            module='DOWNLOAD_RECEIPT'
            message={message}
            linkPath='/beneficiary-transfers'
          />
        )
      default:
        return renderForm()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderForm() {
    return (
      <>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <p style={{ fontSize: 10, fontWeight: 600, paddingLeft: 30 }}>To</p>
        <BeneficiaryDisplay beneDetails={beneDetails} />
        <Formik
          initialValues={{
            transferAmount: '',
            remarks: '',
            txnCurrency: beneDetails?.beneCurrency,
            transferType: config.TRANSFER_TYPES.includes('DDACC') ? 'DDACC' : 'RTGS',
            customRemarks: '',
            isScheduled: 'No',
            scheduledDate: '',
          }}
          enableReinitialize
          validationSchema={OtherTransferSchema}
          onSubmit={onVerify}>
          {({ isSubmitting, errors, touched, setFieldValue, handleChange, values }) => (
            <Form>
              <div>
                <label style={{ display: 'block' }} className='control-label'>
                  {t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_DETAILS_KEYS.TRANSFER_TYPE)}
                </label>
                {config.TRANSFER_TYPES.includes('DDACC') && (
                  <div className='custom-control custom-radio custom-control-inline pt-20'>
                    <Field
                      as='input'
                      type='radio'
                      id='transferTypeSelect1'
                      name='transferType'
                      value='DDACC'
                      className='custom-control-input'
                    />
                    <label className='custom-control-label' htmlFor='transferTypeSelect1'>
                      {t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_DETAILS_KEYS.DDACC)}
                    </label>
                  </div>
                )}
                {config.TRANSFER_TYPES.includes('RTGS') && (
                  <div className='custom-control custom-radio custom-control-inline'>
                    <Field
                      as='input'
                      type='radio'
                      id='transferTypeSelect2'
                      name='transferType'
                      value='RTGS'
                      className='custom-control-input'
                    />
                    <label className='custom-control-label' htmlFor='transferTypeSelect2'>
                      {t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_DETAILS_KEYS.RTGS)}
                    </label>
                  </div>
                )}
              </div>

              <div className='form-group'>
                <NeoInput
                  tabIndex='1'
                  showAsterisk={otherTransferConfig['isAmountRequired']}
                  text={t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_CONFIRM_KEYS.TRANSFER_AMOUNT)}
                  name='amount'
                  onChange={(values) => {
                    setFieldValue('transferAmount', values.value)
                  }}
                  mode='amount'
                />
                <InputError text={errors.transferAmount} touched={touched.transferAmount} />
                <InputError
                  text={t(VALIDATION_MESSAGES.AMOUNT_VALID)}
                  touched={values.transferAmount === '0.00' || values.transferAmount === '.00'}
                />
                {/* <InputError
                  text={'Insufficient Balance in Selected Account'}
                  touched={parseInt(currentAccountDetail?.odBal) <= parseInt(values.transferAmount)}
                /> */}
              </div>

              {config.SCHEDULED_TRANSFERS && (
                <>
                  <div className='mt-3 form-group'>
                    <NeoInput
                      tabIndex='2'
                      showAsterisk={otherTransferConfig['isSchedulePaymentRequired']}
                      text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.SCHEDULE_TRANSFER)}
                      mode='select'
                      name='isScheduled'
                      onChange={(e) => {
                        handleChange(e)
                      }}
                      list={['Yes', 'No']}
                      keyValue={null}
                    />
                    <InputError text={errors.isScheduled} touched={touched.isScheduled} />
                  </div>

                  {values.isScheduled === 'Yes' && (
                    <div className='form-group mt-3'>
                      <NeoInput
                        tabIndex='3'
                        showAsterisk={otherTransferConfig['isScheduleDateRequired']}
                        name='scheduledDate'
                        text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.SCHEDULE_DATE)}
                        icon='calendar_today'
                        mode='single'
                        type='date'
                        onChange={handleChange}
                        min={moment(new Date()).format('YYYY-MM-DD')}
                      />
                      <InputError text={errors.scheduledDate} touched={touched.scheduledDate} />
                    </div>
                  )}
                </>
              )}

              <div className='mt-3 form-group'>
                <NeoInput
                  tabIndex='4'
                  showAsterisk={otherTransferConfig['isRemarksRequired']}
                  text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.REMARKS)}
                  mode='select'
                  name='remarks'
                  onChange={(e) => {
                    handleChange(e)
                  }}
                  list={remarksList}
                  keyValue={null}
                />
                <InputError text={errors.remarks} touched={touched.remarks} />
              </div>

              {values.remarks === 'Custom' && (
                <div className='row'>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='5'
                      showAsterisk={otherTransferConfig['isCustomRemarksRequired']}
                      text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.CUSTOM_REMARK)}
                      onChange={handleChange}
                      name='customRemarks'
                      maxLength={config.REMARKS_MAX}
                    />
                    <InputError text={errors.customRemarks} touched={touched.customRemarks} />
                  </div>
                </div>
              )}

              <div className='mt-3'>
                {isSubmitting ? (
                  renderLoading()
                ) : (
                  <NeoButton
                    tabIndex='5'
                    type='submit'
                    mode={'newDesign'}
                    disabled={isSubmitting}
                    text={t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_DETAILS_KEYS.SUBMIT)}
                  />
                )}
              </div>
              <div className='back-cancel-btn-container'>
                <button
                  className='back-cancel-btn btn btn-sm new-design-warning-text-color'
                  tabIndex={'6'}
                  onClick={() => history.goBack()}>
                  {' '}
                  {t(SIDENAV_KEYS.TOUCH_ID_KEYS.CANCEL)}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </>
    )
  }

  function renderConfirm() {
    return (
      <>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <p style={{ fontSize: 10, fontWeight: 600, paddingLeft: 30 }}>To</p>
        <BeneficiaryDisplay beneDetails={beneDetails} />

        <div className='d-flex flex-column confirmation'>
          <div>
            <h6 className='label'>
              {t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_DETAILS_KEYS.TRANSFER_TYPE)}
            </h6>
            <h6 className='value'>
              {formValues?.transferType === 'DDACC'
                ? t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_DETAILS_KEYS.DDACC)
                : t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_DETAILS_KEYS.RTGS)}
            </h6>
          </div>
          <div>
            <h6 className='label'>
              {t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_CONFIRM_KEYS.TRANSFER_AMOUNT1)}
            </h6>
            <h6 className='value'>{formValues?.transferAmount}</h6>
          </div>
          <div>
            <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_CONFIRM_KEYS.currency)}</h6>
            <h6 className='value'>{formValues.txnCurrency}</h6>
          </div>
          {config.SCHEDULED_TRANSFERS && (
            <>
              <div>
                <h6 className='label'>{t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.SCHEDULE_TRANSFER)}</h6>
                <h6 className='value'>{formValues?.isScheduled}</h6>
              </div>
              {formValues.isScheduled === 'Yes' && (
                <div>
                  <h6 className='label'>{t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.SCHEDULE_DATE1)}</h6>
                  <h6 className='value'>{moment(formValues.scheduledDate).format('DD-MM-YYYY')}</h6>
                </div>
              )}
            </>
          )}
          <div>
            <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_CONFIRM_KEYS.CHARGES)}</h6>
            <h6 className='value'>
              <NumberFormat
                value={verifyDetails?.charges || 0}
                displayType={'text'}
                thousandSeparator={true}
                prefix={''}
                fixedDecimalScale={true}
                decimalScale={2}
                allowEmptyFormatting
              />
            </h6>
          </div>
          <div>
            <h6 className='label'>
              {t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.REMARKS1)}
            </h6>
            <h6 className='value'>
              {formValues.remarks === 'Custom' ? formValues.customRemarks : formValues.remarks}
            </h6>
          </div>

          <div>
            <TermsAndCondition module='BENEFICIARYTRANSFER' />
          </div>

          <div className='mt-3'>
            {loading ? (
              renderLoading()
            ) : (
              <NeoButton
                mode='newDesign'
                type='button'
                className='btn btn-neo'
                onClick={() =>
                  verifyDetails.repeat ? showConfirmModal() : otpEnabled ? setStage(3) : onConfirm()
                }
                text={t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_CONFIRM_KEYS.CONFIRM)}
              />
            )}
          </div>
          <div className='back-cancel-style' onClick={() => setStage(1)}>
            {' '}
            {t(SIDENAV_KEYS.TOUCH_ID_KEYS.BACK)}
          </div>
        </div>
      </>
    )
  }

  return (
    <LayoutWithAccountCard breadCumKey='TRANSFER_OTHER'>
      <div className='new-design-form-style'>
        <div className='heading-style'>
          {t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_TRANSFER.DOMESTIC_TRANSFER_TITLE)}
        </div>

        <div>{renderSwitch()}</div>
      </div>
    </LayoutWithAccountCard>
  )
}
